import gql from "graphql-tag"

import criticsReview from "../criticsReview"
import image from "../image"
import mas from "../mas/mas"
import homeVideo from "./homeVideo"

const GET_HOME_VIDEO_REVIEW = gql`
  ${criticsReview}
  ${homeVideo}
  ${image}
  ${mas}

  fragment HomeVideoReview on HomeVideoReview {
    avForums {
      ...CriticsReview
    }
    avNirvana {
      ...CriticsReview
    }
    avsForum {
      ...CriticsReview
    }
    bluRay {
      ...CriticsReview
    }
    bluRayAuthority {
      ...CriticsReview
    }
    digitalBits {
      ...CriticsReview
    }
    doBlu {
      ...CriticsReview
    }
    hidefDigest {
      ...CriticsReview
    }
    highDefDiscNews {
      ...CriticsReview
    }
    homeTheaterForum {
      ...CriticsReview
    }
    homeVideo {
      ...HomeVideo
    }
    id
    images {
      ...Image
    }
    isPublished
    mas {
      ...MAS
    }
    name
    publishedAt
    score {
      audio
      extra
      movie
      total
      video
    }
    summary {
      audio {
        long
        short
      }
      extra {
        long
        short
      }
      movie {
        long
        short
      }
      total {
        long
        short
      }
      video {
        long
        short
      }
    }
    theaterByte {
      ...CriticsReview
    }
    whySoBlu {
      ...CriticsReview
    }
  }
`

export default GET_HOME_VIDEO_REVIEW
